<div class="overview-container" *ngIf="selectedRowFilter && selectedRowFilter?.name && selectedColumnFilter && selectedColumnFilter?.name">
    <div [class.fullscreen]="drillDownCardFullScreen" (click)="onWidgetClick($event)">
        <div class="left-conteiner" #drilldownCardContainer>
            <div class="header-panel paddding-bottom-20">
                <div class="left-header-panel">
                    <div class="widget-title">
                        Score
                    </div>
                    <div class="widget-description">
                        {{desclaimer.main}}
                    </div>
                </div>
                <div class="right-header-panel" [class.disabled]="!isOverallDataLoading && !isOverallDataAvailable">
                    <app-score-widget [ngStyle]="{'margin-left': '12px'}" [config]="getWidgetConfig('drilldown')"
                        (onDownloadClick)="onDownload('drilldown')"
                        (onFullscreenClick)="onFullScreen($event, 'drilldown')"></app-score-widget>
                </div>
            </div>
            <!-- <div class="tab-panel paddding-bottom-20">
                <button (click)="changeTableView($event,'list')" class="widget-tabs"
                    [class.acitve]="selectedTableView == 'list'">
                    List
                </button>
                <button (click)="changeTableView($event,'heatmap')" class="widget-tabs"
                    [class.acitve]="selectedTableView == 'heatmap'">
                    Heatmap
                </button>
            </div> -->
            <div class="control-panel paddding-bottom-20">
                <div class="left-controls">
                    <div class="tab-panel">
                        <button (click)="changeTableView($event,'list')" class="widget-tabs"
                            [class.acitve]="selectedTableView == 'list'">
                            List
                        </button>
                        <button (click)="changeTableView($event,'heatmap')" class="widget-tabs"
                            [class.acitve]="selectedTableView == 'heatmap'">
                            Heatmap
                        </button>
                    </div>
                    <div class="litmus-checkbox-control" *ngIf="selectedTableView == 'heatmap'">
                        <input type="checkbox" id="show_color_only" [checked]="(ddTableConfig.hideText)?'checked':''"
                            name="check" value="" />
                        <label for="show_color_only" (click)="showFeedsby($event)">
                            <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                            <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                            Show colors only
                        </label>
                    </div>
                </div>
                <div class="right-controls">
                    <div class="dropdown-control">
                        <span>View rows by</span>
                        <app-score-dropdown-menu #dropdownChild1 [config]="rowDropdown.config"
                            [selectedOption]="rowDropdown?.selectedOption" [options]="rowDropdown?.options"
                            (selectedOptionChange)="dropdownOptionChange($event, 'row')"></app-score-dropdown-menu>
                    </div>
                    <div class="dropdown-control">
                        <span>View columns by</span>
                        <app-score-dropdown-menu #dropdownChild1 [config]="columnDropdown.config"
                            [selectedOption]="columnDropdown?.selectedOption" [options]="columnDropdown?.options"
                            (selectedOptionChange)="dropdownOptionChange($event, 'column')"></app-score-dropdown-menu>
                    </div>
                </div>
            </div>
            <div class="drilldown-table-container">
                <app-overview-table *ngIf="(!isOverallDataLoading && isOverallDataAvailable)" [selectedRow]="selectedRow" [config]="ddTableConfig" [columns]="overallTable.header"
                    (onDrillDown)="onDrillDown($event,'overall')" [type]="'drilldown'" (onSelect)="onRowSelect($event,'overall')" [fixedColumns]="overallTable.fixedHeader"
                    [rows]="overallTable.row" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel"></app-overview-table>
                <app-overview-table *ngIf="(!isDrilldownDataLoading && isDrilldownDataAvailable)" [selectedRow]="selectedRow" [config]="ddTableConfig" [columns]="drilldownTable.header"
                    (onDrillDown)="onDrillDown($event,'drilldown')" [type]="'drilldown'" (onSelect)="onRowSelect($event,'drilldown')"[fixedColumns]="drilldownTable.fixedHeader"
                    [rows]="drilldownTable.row" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel"></app-overview-table>
                <div class="performers-loader" *ngIf="isDrilldownDataLoading || isOverallDataLoading ">
                    <app-ltms-loader></app-ltms-loader>
                </div>
                <div class="performers-error" *ngIf="(!isOverallDataLoading && !isOverallDataAvailable) || (!isDrilldownDataLoading && !isDrilldownDataAvailable)">
                    No data available for selected filters.
                </div>
            </div>
        </div>
    </div>
    <div class="right-conteiner">
        <div class="top-performers-card">
            <div class="header-panel paddding-bottom-20">
                <div class="left-header-panel">
                    <div class="widget-title">
                        Top 5 performers
                    </div>
                    <div class="widget-description">
                        {{desclaimer.topperformer}}
                    </div>
                </div>
                <div class="right-header-panel" [class.disabled]="!isPerformerDataLoading && !isPerformerDataAvailable">
                    <app-score-widget [ngStyle]="{'margin-left': '12px'}" [config]="getWidgetConfig('top_performers')"
                        (onDownloadClick)="onDownload('top_performers')"></app-score-widget>
                </div>
            </div>
            <div>
                <div class="performers-loader" *ngIf="isPerformerDataLoading">
                    <app-ltms-loader></app-ltms-loader>
                </div>
                <div class="performers-error" *ngIf="!isPerformerDataAvailable && !isPerformerDataLoading">
                    No data available for selected filters.
                </div>
                <app-overview-table *ngIf="!isPerformerDataLoading && isPerformerDataAvailable"
                    [columns]="performersColumns" [rows]="topResponses" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel"></app-overview-table>
            </div>
        </div>
        <div class="bottom-performers-card">
            <div class="header-panel paddding-bottom-20">
                <div class="left-header-panel">
                    <div class="widget-title">
                        Bottom 5 performers
                    </div>
                    <div class="widget-description">
                       {{desclaimer.bottomPerformer}}
                    </div>
                </div>
                <div class="right-header-panel" [class.disabled]="!isPerformerDataLoading && !isPerformerDataAvailable">
                    <app-score-widget [ngStyle]="{'margin-left': '12px'}"
                        [config]="getWidgetConfig('bottom_performers')"
                        (onDownloadClick)="onDownload('bottom_performers')"></app-score-widget>
                </div>
            </div>
            <div>
                <div class="performers-loader" *ngIf="isPerformerDataLoading">
                    <app-ltms-loader></app-ltms-loader>
                </div>
                <div class="performers-error" *ngIf="!isPerformerDataAvailable && !isPerformerDataLoading">
                    No data available for selected filters.
                </div>
                <app-overview-table *ngIf="isPerformerDataAvailable && !isPerformerDataLoading"
                    [columns]="performersColumns" [rows]="bottomResponses" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel"></app-overview-table>
            </div>
        </div>
    </div>
</div>
<div class="overview-config-error" *ngIf="!(selectedRowFilter && selectedRowFilter?.name) || !(selectedColumnFilter && selectedColumnFilter?.name)">
    Required configuration is unavailable. Contact your admin for support.
</div>